const database = [
    { id: 1, name: 'Free Magazine', content: '', image: require("@/assets/img/design1.png") },
    { id: 2, name: 'Free Magazine', content: '', image: require("@/assets/img/design2.png") },
    { id: 3, name: 'Free Magazine', content: '', image: require("@/assets/img/design3.png") },
    { id: 4, name: 'Free Magazine', content: '', image: require("@/assets/img/design4.png") },
    { id: 5, name: 'Free Magazine', content: '', image: require("@/assets/img/design5.png") },
    { id: 6, name: 'Free Magazine', content: '', image: require("@/assets/img/design6.png") },
    { id: 7, name: 'Free Magazine', content: '', image: require("@/assets/img/design7.png") },
    { id: 8, name: 'Free Magazine', content: '', image: require("@/assets/img/design8.png") },
    { id: 9, name: 'Free Magazine', content: '', image: require("@/assets/img/design9.png") },
    { id: 10, name: 'FM OnAir Site', content: '', image: require("@/assets/img/web_design1.png") },
    { id: 11, name: 'FM OnAir Site', content: '', image: require("@/assets/img/web_design2.png") },
]

export default {
    fetch(id) { return database },
    find(id) { return database.find(el => el.id === id) },
    asyncFind(id, callback) {
        setTimeout(() => {
            callback(database.find(el => el.id === id))
        }, 100)
    }
}


// WEBPACK FOOTER //
// ./src/api/products.js